import translations from "./translations.js";

const config = {
    disablePageInteraction: !window.core.allow_without_cookies,

    categories: {
        necessary: {
            enabled: true,
            readOnly: true,
        },
        analytics: {
            enabled: true,
            readOnly: false,
        },
        marketing: {
            enabled: true,
            readOnly: false,
        },
    },

    guiOptions: {
        consentModal: {
            layout: "cloud",
            position: "bottom center",
            equalWeightButtons: true,
            flipButtons: false,
        },
        preferencesModal: {
            layout: "box",
            equalWeightButtons: true,
            flipButtons: false,
        },
    },

    language: {
        default: "default",
        translations,
    },
};

export default config;
